import { render } from "./ClavesTecnicas.vue?vue&type=template&id=057dc1f0"
import script from "./ClavesTecnicas.vue?vue&type=script&lang=js"
export * from "./ClavesTecnicas.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__